import React from "react";
import { Link } from "react-router-dom";
import { PauseCircle } from "lucide-react";
import { useSiteSettings } from "../../hooks/siteSettings";
import DahliasShell from "./DahliasShell";

export function useSales() {
  const settings = useSiteSettings();
  return settings?.sales || {};
}

/** Wraps Store / Catalogue / Cart / Checkout routes. `area` = "store" | "catalogue" | "checkout". */
export default function SalesGate({ area, children }) {
  const sales = useSales();
  const blocked = (area === "store" && (sales.paused || sales.hide_store))
    || (area === "catalogue" && sales.hide_catalogue)
    || (area === "checkout" && sales.paused);
  if (!blocked) return children;
  return (
    <DahliasShell>
      <section className="bg-[var(--dahlias-cream)] min-h-[60vh] flex items-center" data-testid="sales-paused-panel">
        <div className="max-w-xl mx-auto px-5 py-16 text-center">
          <PauseCircle className="w-10 h-10 mx-auto text-[var(--berry)]" />
          <div className="font-label tracking-[0.4em] text-[10px] text-[var(--berry)] mt-4">✦ HERITAGE DAHLIAS ✦</div>
          <h1 className="font-display text-4xl sm:text-5xl text-[var(--dahlias-ink)] mt-2">{sales.paused ? "Sales are paused" : "Taking a short break"}</h1>
          <p className="mt-4 text-[var(--dahlias-ink)]/75">{sales.message || "We're catching up on orders and stock. Existing orders are safe , check Heritage HQ for updates."}</p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link to="/account" className="px-6 py-3 rounded-full bg-[var(--berry)] text-white font-label text-xs tracking-[0.3em] uppercase" data-testid="sales-paused-hq">My HQ</Link>
            <Link to="/dahlias" className="px-6 py-3 rounded-full border-2 border-[var(--berry)]/40 text-[var(--berry)] font-label text-xs tracking-[0.3em] uppercase">Home</Link>
          </div>
        </div>
      </section>
    </DahliasShell>
  );
}
